import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppConfig } from './app.config';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';
import { LoginService } from './services/login/login.service';
import { HttpRequestInterceptorService } from './services/httpRequestInterceptor.service';
import { AuthGuard } from './services/auth-guard.service';
import { DeclarationsListService } from './in/mes-declarations/services/declarations-list.service';
import { DeclarationsCollectivitesClientesService } from './in/mes-declarations/services/declarations-collectivites-clientes.service';
import { DeclarationsDechetsMenagersService } from './in/mes-declarations/services/declarations-dechets-menagers.service';
import { DeclarationsMetauxMachefersService } from './in/mes-declarations/services/declarations-metaux-machefers.service';
import { DeclarationsJustifsService } from './in/mes-declarations/services/declarations-justifs.service';
import { RefreshTokenService } from './services/refresh.service';
import { HttpResponseInterceptorService } from './services/httpResponseInterceptor.service';
import { DeclarationsService } from './in/mes-declarations/services/declarations.service';
import { ChangePasswordService } from './in/services/change-password.service';
import { ForgotPasswdService } from './services/login/forgot-passwd.service';
import { MesCollectivitesService } from './in/mes-collectivites/services/mes-collectivites.service';
import { ContactsService } from './in/contact/services/contact.service';
import { ModalService } from './services/modal/modal.service';
import { DeclarationsValidationService } from './in/mes-declarations/services/declarations-validation.service';
import { ResetPasswordService } from './services/login/reset-password';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule
  ],
  providers: [
    AppConfig,
    { provide: APP_INITIALIZER, useFactory: (config: AppConfig) => () => config.load(), deps: [AppConfig], multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpResponseInterceptorService, multi: true },
    RefreshTokenService,
    ModalService,
    LoginService,
    DeclarationsListService,
    DeclarationsCollectivitesClientesService,
    DeclarationsDechetsMenagersService,
    DeclarationsMetauxMachefersService,
    DeclarationsJustifsService,
    DeclarationsService,
    ChangePasswordService,
    ForgotPasswdService,
    MesCollectivitesService,
    ContactsService,
    DeclarationsValidationService,
    ResetPasswordService,
    AuthGuard
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts